import * as Sentry from '@sentry/react';
import { Routes } from 'react-router-dom';

if (!import.meta.env.DEV)
  Sentry.init({
    dsn: 'https://4cd42dface68a913ad091d691f6fb40f@o467030.ingest.us.sentry.io/4508359602929664',
    environment: import.meta.env.VITE_APP_ENV,
    release: import.meta.env.VITE_APP_VERSION,
  });

export const SentryRoutes = Routes;

export function setSentryUser(email: string): void {
  Sentry.setUser({ email });
}

export function clearSentryUser(): void {
  Sentry.setUser(null);
}
